/* eslint-disable jira/js/no-reduce-accumulator-spread */

// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type {
	CategoryId,
	GenericError,
	Knowledge,
} from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import KnowledgeHubPushProvider, {
	type PushHistory,
} from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/knowledge-hub-push-provider/index.tsx';
import { withRouter } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/knowledge-hub-with-router/index.tsx';
import { browseKnowledge } from '../../../state/actions/browse-knowledge/index.tsx';
import { getArticlesByIds } from '../../../state/selectors/articles/index.tsx';
import {
	getArticleIdsForCategory,
	getCategoryTotalSize,
	getBrowseLimit,
	isBrowseLoading,
	getArticlesLoading,
} from '../../../state/selectors/browse/index.tsx';
import KnowledgeTable, { type KnowledgeTableProps } from './view.tsx';

export type ConnectedKnowledgeProps = {
	categoryId: CategoryId;
	sortBy: KnowledgeTableProps['sortBy'];
	expansions: KnowledgeTableProps['expansions'];
	page: KnowledgeTableProps['page'];
	columns: KnowledgeTableProps['columns'];
	emptyStateComponent: KnowledgeTableProps['emptyStateComponent'];
	noSearchResultsComponent: KnowledgeTableProps['noSearchResultsComponent'];
	onSetPage: KnowledgeTableProps['onSetPage'];
};

type InternalProps = JSX.LibraryManagedAttributes<
	typeof KnowledgeTable,
	ComponentProps<typeof KnowledgeTable>
> &
	ConnectedKnowledgeProps;
type ExternalProps = Flow.Diff<
	InternalProps,
	{
		push: PushHistory;
	}
>;

const KnowledgeTableWithPush = (props: ExternalProps) => (
	<KnowledgeHubPushProvider>
		{({ push }) => <KnowledgeTable {...props} push={push} />}
	</KnowledgeHubPushProvider>
);

export const ConnectedKnowledgeTable = connect(
	(state, props) => {
		// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'. | TS2339 - Property 'categoryId' does not exist on type '{}'. | TS2339 - Property 'page' does not exist on type '{}'.
		const articleIds = getArticleIdsForCategory(state, props.categoryId, props.page);
		let totalSize: number | undefined;
		let knowledgePieces: Knowledge[] | undefined;
		let error: GenericError | undefined;

		if (articleIds) {
			// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'string[] | GenericError'.
			if (articleIds.error && !Array.isArray(articleIds)) {
				error = articleIds;
			} else {
				// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'. | TS2339 - Property 'categoryId' does not exist on type '{}'.
				totalSize = getCategoryTotalSize(state, props.categoryId);
				// @ts-expect-error - TS2322 - Type 'Article | GenericError' is not assignable to type 'Article[] | undefined'. | TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
				knowledgePieces = getArticlesByIds(state, articleIds).reduce<Knowledge[]>(
					// @ts-expect-error - TS2322 - Type '(Article | GenericError)[]' is not assignable to type 'Article[]'. | TS2339 - Property 'error' does not exist on type 'Article | GenericError'.
					(acc, curr) => (curr.error ? acc : [...acc, curr]),
					// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					[] as Knowledge[],
				);
			}
		}

		return {
			totalSize,
			knowledgePieces,
			error,
			// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'. | TS2339 - Property 'categoryId' does not exist on type '{}'.
			isInitiallyLoading: isBrowseLoading(state, props.categoryId),
			// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
			limit: getBrowseLimit(state),
			// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type 'State'.
			isSearchLoading: getArticlesLoading(state),
		};
	},
	{
		onBrowseKnowledge: browseKnowledge,
	},
)(KnowledgeTableWithPush);

export default withRouter(KnowledgeTableWithPush);
